export default __webpack_public_path__ + "static/media/OnlineShopping.b29f6516.PNG";